import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 md:pl-8" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col mx-auto" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex flex-col md:flex-row mr-auto" }
const _hoisted_8 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto" }
const _hoisted_9 = { class: "py-6" }
const _hoisted_10 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_11 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import {
  inject,
  onMounted,
  ref,
  resolveComponent,
  shallowRef,
  watch,
} from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import LiveTransactionFitlerDialog from "@/components/dialogs/LiveTransactionFilterDialog.vue";
import { formatNumber, translate } from "@/utils/tools";
import router from "@/router";
import PopOver from "@/components/tools/PopOver.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const popOver = shallowRef(PopOver);
const columns = ref([
  {
    label: translate("messages.liveTransaction.action"),
    field: "action",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.action == "DEPOSIT" ? "ฝาก" : data.action == "WITHDRAW" ? "ถอน" : "อื่นๆ"),
    class: (data: any) => {
      let baseClass = `inline-block px-2 py-1 rounded-lg text-white text-xs font-bold`;
      if (data.action == "DEPOSIT") baseClass += ` bg-green-600`;
      else if (data.action == "WITHDRAW") baseClass += ` bg-red-600`;
      else baseClass += ` bg-yellow-600`;
      return baseClass;
    },
  },
  {
    label: translate("messages.liveTransaction.from"),
    field: "moduleCode",
    isSorted: false,
    sort: true,
    format: (data: any) => checkRawData({ data: data, mode: "requestBody" }),
  },
  {
    label: translate("messages.liveTransaction.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.amount, 1),
    class: (data: any) =>
      Number(data.amount) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.liveTransaction.date"),
    field: "created_at",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.liveTransaction.user"),
    field: "username",
    sort: true,
    isSorted: false,
    format: (data: any) => checkRawData({ data: data, mode: "username" }),
    isFunction: true,
    function: (data: any) => {
      window.open(`/players/${data.userId}`, '_blank');
      // router.push(`/players/${data.userId}`);
    },
  },
  {
    label: translate("messages.liveTransaction.approver"),
    field: "",
    align: "center",
    element: popOver,
    format: (data: any) => "Approver",
  },
  // {
  //   label: "Approved By",
  //   field: "admin",
  //   align: "center",
  //   sort: true,
  //   isSorted: false,
  //   format: (data: any) => checkRawData({ data: data, mode: "payduty" }),
  // },
]);

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  // isEmitOnClick: true,
  sort: [["seq_num", "DESC"]],
});

const filterForm = ref({
  action: null,
  moduleCode: null,
  from: null,
  to: null,
});

const filterModal = (data = { flag: 0, action: null, moduleCode: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;

  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.action = data.action;
    filterForm.value.moduleCode = data.moduleCode;

    fetchPageData();
  }
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  attName = attName.split(" ").join("_").toLowerCase();
  if (attName === "Date" || attName === "date") attName = "seq_num";
  if (attName === "user") attName = "username";
  if (attName === "approved_by") attName = "createdBy";
  if (attName === "from") attName = "moduleCode";
  sort[0] = [attName, mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};

const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { moduleCode, action, from, to } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page - 1,
    pageSize: rowsPerPage,
    filter: {
      moduleCode: moduleCode || [...store.state.financeModuleCode, 'ADMIN', 'SYSTEM', 'PAYDUTY','AFFILIATE_COMMISSION', 'AFFILIATE_DOWNLINE', 'LOYALTY_REDEEM','TOPUP_CASH'],
      action: action || null,
      startDate: dayjs(from).valueOf() || null,
      endDate: dayjs(to).valueOf() || null,
      username: search,
    },
    sortBy: sort.map((x) => [x[0], x[1] == "DESC" ? -1 : 1]),
  };
  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/cms/withdraw-deposit-record-all/pagination`;

  const { result: data } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  // if(!data || data.length == 0){
  //   if(page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = data.length;

  // if (data.length > 0) dataRows.value = data
  dataRows.value = data;
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `transaction?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
watch(
  () => pageConfig.value.search,
  // () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
const checkRawData = ({ data, mode }: any) => {
  if (mode === "requestBody") {
    if (data.refCode5) {
      return data.refCode5;
    } else if (data.moduleCode) {
      return data.moduleCode;
    } else {
      // if (data.rawData && data.rawData.requestBody) {
      //   if (data.rawData.requestBody && data.rawData.requestBody.type) {
      //     return data.rawData.requestBody.type
      //   } else {
      //     return data.moduleCode
      //   }
      // } else {
      return "-";
      // }
    }
  }
  if (mode === "username") {
    if (data.userdata7) {
      return data.userdata7;
      // }
      // if (data.rawData && data.rawData.requestBody) {
      // if (data.rawData.requestBody && data.rawData.requestBody.username) {
      //   return data.rawData.requestBody.username
      // } else {
      // return data.userId
      // }
    } else {
      return data.username || data.userId;
      // return "-"
    }
  }
  if (mode === "payduty") {
    if (data.moduleCode === "PAYDUTY") return "-";

    if (data.rawData) {
      if (data.rawData.requestBody && data.rawData.requestBody.admin) {
        return data.rawData.requestBody.admin;
      } else return "-";
    } else return "-";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.liveTransaction.liveTransaction')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(SearchIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
                maxlength: "10",
                class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
                type: "search",
                name: "search",
                placeholder: _ctx.$t('messages.liveTransaction.search')
              }, null, 8, _hoisted_6), [
                [_vModelText, pageConfig.value.search]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DateSelector, { onSearch: onSearch })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (filterModal())),
              class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-white mr-2",
                icon: ['far', 'filter'],
                transform: ""
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.liveTransaction.advanceFilter")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(DataTable, {
              columns: columns.value,
              data: dataRows.value,
              onSort: doSort,
              isLoaded: isLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(LiveTransactionFitlerDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})